module.exports = __webpack_public_path__ + "static/carbon-datepicker-basic-calendar-40868ec5e274b9c1cf26b86d291eb3d8.png";